<template>
	<el-popover
		placement="bottom-end"
		title=""
		:width="231"
		trigger="click"
		popper-class="addtag-popover"
		:append-to-body="false"
    @show="getTagsList"
    @hide="tagText=''"
	>
		<div class="addtag-wrapper">
			<div class="addtag-wrapper-t">
				<el-input class="addtag-wrapper-t-input" v-model="tagText" placeholder="选择创建客户标签"></el-input>
				<el-button class="addtag-wrapper-t-button" @click="handleSaveTags" size="small">创建</el-button>
			</div>
			<ul class="addtag-wrapper-ul">
				<!-- <li class="addtag-wrapper-li exist">6月储备客户-1</li>
				<li class="addtag-wrapper-li loading">6月储备客户-2</li> -->
				<li 
          v-for="tag in allTagList"
          :key="tag.id"
          @click="handleAddOrRemoveTag(tag.id)"
          :class="{
            'addtag-wrapper-li': true,
            'exist': tagedList.includes(tag.id),
            'loading': tag.id === loadingId
          }"
        >{{ tag.name }}</li>
			</ul>
		</div>
		<slot slot="reference"></slot>
	</el-popover>
</template>

<script>
import { tagsList, addCustomerTag, saveTags, deleteCustomerTag } from '@/utils/api/customerdetail.js';


export default {
	name: 'add-tags-popover',
  props: {
    customerId: Number | null,
    tagedCollect: {
      require: true,
      type: Array,
      default: []
    }
  },
	data() {
		return {
      tagText: '',  //标签名称
      submitLoading: false, //提交时的loading，禁用乱其他点击
      allTagList: [], //所有的标签列表数据
      loadingId: null, //当前哪个标签正在进行选中或取消选中的操作
      tagedList: [],  //已经勾选过的，在created处从列表item获得
		}
	},
  watch: {
    tagedCollect() {
      // 当列表条数不变时，再搜出来新的tagList不会更新到组件内部
      this.initTagedList();
    }
  },
  methods: {
    // 获取所有标签列表
    getTagsList(taged=[]) {
      const params = {
        excludeTags: taged
      }
      tagsList(params)
        .then(res => {
          if (res.rspResult.bizCode == 200) {
            this.allTagList = (res.rspListData.list || []);
          }
        })
        .catch(err => console.error("智搜，获取标签列表失败了", err));
    },
    // 统一判断是打标签还是移除标签
    handleAddOrRemoveTag(_tagId) {
      if(this.tagedList.includes(_tagId)) {
        // 移除标签
        this.handleRemoveCustomerTag(_tagId);
      }else {
        // 打上标签
        this.handleAddCustomerTag(_tagId);
      }
    },
    // 给这个客户(公司)打上某个标签
    handleAddCustomerTag(_tagId, isNeedReload=false) {
      if(this.loadingId || this.submitLoading) return;
      this.loadingId = _tagId
      const params = {
        customerId: this.customerId,
        tagId:_tagId
      }
      addCustomerTag(params)
        .then(res => {
          this.loadingId = null;
          if (res.rspResult.bizCode == 200) {
            this.tagedList.push(_tagId);
            this.$message.success(res.rspResult.message);
            isNeedReload && this.getTagsList(); //获取最新的已选中的标签列表(貌似用不上了，拿id手动拼接上即可)
          }
        })
        .catch(err => {
          this.loadingId = null;
          console.error("打标签失败了", err)
        });
    },
    // 给这个客户(公司)移除某个标签
    handleRemoveCustomerTag(_tagId) {
      if(this.loadingId || this.submitLoading) return;
      this.loadingId = _tagId
      const params = {
        customerId: this.customerId,
        tagId:_tagId
      }
      deleteCustomerTag(params)
        .then(res => {
          this.loadingId = null;
          if (res.rspResult.bizCode == 200) {
            this.$message.success(res.rspResult.message);
            const _index = this.tagedList.findIndex(_id => _id === _tagId);
            this.tagedList.splice(_index, 1);
          }
        })
        .catch(err => {
          this.loadingId = null;
          console.error("打标签失败了", err)
        });
    },
    // 新建标签
    handleSaveTags() {
      if(this.submitLoading || this.loadingId) return;
      this.submitLoading = true;
      const _tagText = this.tagText.trim();
      if(!_tagText) {
        this.submitLoading = false;
        return this.$message.warning('请输入客户标签名称');
      };
      const params = {
        color: "#20B820",
        name: _tagText
      }
      saveTags(params)
        .then(res => {
          this.submitLoading = false;
          this.tagText = '';  //清空输入框
          if (res.rspResult.bizCode == 200) {
            const _id = res.data.id;
            this.allTagList.unshift({
              id: _id,
              name: _tagText
            })
            // 顺势把该标签打上
            this.handleAddCustomerTag(_id);
          }
        })
        .catch(err => {
          this.submitLoading = false;
          console.error("打标签失败了", err)
        });
    },
    // 初始赋值
    initTagedList() {
      if(this.tagedCollect.length) {
        this.tagedList = this.tagedCollect.map(item=> item.id);
      }
    },

  },
  created() {
    this.initTagedList();
  },
}
</script>

<style lang="scss" scoped>
@keyframes rotateLoop {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
::v-deep .addtag-popover {
  padding: 12px 0 12px 16px;
  .addtag-wrapper {
    &-t {
      display: flex;
      width: 195px;
      padding-bottom: 12px;
      margin-bottom: 8px;
      border-bottom: 1px solid #EDF0F4;
      &-input {
        .el-input__inner {
          border: 0;
          font-family: SourceHanSansCN-Regular;
          font-weight: 400;
          font-size: 14px;
          letter-spacing: 0;
          padding: 0 15px 0 0px;
          border-radius: 0;
          &::placeholder {
            color: #98A3B7;
          }
        }
      }
      &-button {
        flex-shrink: 0;
        width: 52px;
        padding: 8px 0;
        font-family: SourceHanSansCN-Regular;
        font-weight: 400;
        font-size: 14px;
        line-height: 14px;
        color: #4F5D78;
        letter-spacing: 0;
        text-align: center;
      }
    }
    &-ul {
      width: 204px;
      max-height: 160px;
      overflow-y: auto;
      &::-webkit-scrollbar {
        width: 3px !important;
        display: none;
      }
      &:hover {
        &::-webkit-scrollbar {
          display: block;
        } 
      }
      .addtag-wrapper-li {
        width: 195px;
        box-sizing: border-box;
        height: 40px;
        border-radius: 4px;
        line-height: 40px;
        font-family: SourceHanSansCN-Regular;
        font-weight: 400;
        font-size: 14px;
        color: #16181A;
        letter-spacing: 0;
        padding: 0 36px 0 12px;
        user-select: none;
        position: relative;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        &:hover {
          background: #F5F7FA;
        }
        &.exist {
          &::after {
            font-family: "iconfont" !important;
            font-style: normal;
            -webkit-font-smoothing: antialiased;
  
            content: "\e687";
            position: absolute;
            font-size: 12px;
            color: #066EB7;
            line-height: 40px;
            right: 12px;
						width: 14px;
						text-align: center;
          }
        }
        &.loading {
          &::after {
            font-family: "iconfont" !important;
            font-style: normal;
            -webkit-font-smoothing: antialiased;
            
            content: "\e64a" !important;
            position: absolute;
            height: 14px;
            font-size: 14px;
            color: #066EB7;
            line-height: 14px;
            right: 12px;
            top: 0;
            bottom: 0;
            margin: auto;
            animation: rotateLoop 1.6s infinite linear;
          }
        }
      }
    }
  }
}
</style>